<div class="qatch qatch-product" [attr.data-product-id]="data.product_id">

    <a class="qatch-img {{ getAnalyticClass('click') }}"
       [href]="productUrl(data)"
       target="_blank"
       rel="noopener noreferrer"
       [class.top-right-corner-polygon]="isLoggedIn && !productMeta?.hideReaction"
       (click)="handleCardClick($event, data)">
        <img lazyLoadImage url="{{ data.image_url | encodeImageUri }}"
            [alt]="(data.retailer_name || data.brand_name || 'Product') + ' ' + (data.product_name || 'product')"
            class="card-lazy-img w-100 {{getAnalyticClass('click')}}" (error)="onError.emit()"/>

        <div class="overlay bg-dark-trans desktop-view" *ngIf="data.added">
            <div class="text-light" [class.d-flex]="isMobile">
                <p class="text-center out-off-stock m-auto">Added to your Qatch!</p>
            </div>
        </div>

        <button *ngIf="isLoggedIn && !productMeta?.hideReaction"
            type="button"
            class="wishlist-heart-btn {{ getAnalyticClass('love_click') }}"
            [class.active]="data.reaction_type === 'Loved' || data.reaction_type === 'Liked'"
            (click)="addToQatchWithReaction('Loved', $event)"
            aria-label="Save to wishlist"
            title="Save to wishlist">
            <i class="bi bi-heart-fill" *ngIf="data.reaction_type === 'Loved' || data.reaction_type === 'Liked'; else emptyHeart"></i>
            <ng-template #emptyHeart>
                <i class="bi bi-heart"></i>
            </ng-template>
        </button>

        <div class="promo-code-badge" *ngIf="data.promo_code">
            {{ data.promo_code | uppercase }}
        </div>

        <div class="overlay bg-dark-trans desktop-view" *ngIf="!data.added && data.availability_id === 2">
            <div class="text-light" [class.d-flex]="isMobile">
                <p class="text-center out-off-stock m-auto">Out of Stock!</p>
            </div>
        </div>

        <div class="label-new shadow"
            *ngIf="data.reaction_type === 'New' && (productMeta?.page === 'wishlist' || productMeta?.page === 'my-qatch')">
            <span>NEW</span>
        </div>
    </a>
    <span class="visually-hidden">{{ data.product_name }}</span>
    <div class="text-center pt-2 d-flex justify-content-between px-2 collection-meta-text" *ngIf="isCollectionPage">
        <div class="m-0">{{ data.retailer_name }}</div>
        <div class="m-0">{{ data.price_rating }}</div>
    </div>
    <div class="text-dark text-center pt-2 promo-code" *ngIf="lovedCount >= 50">
        <p class="fw-bold m-0">POPULAR! 🖤</p>
        <div class="m-0 collection-meta-text">{{ lovedCount }} others have saved this piece</div>
    </div>
    <div class="text-dark text-center pt-2 promo-code" *ngIf="data.promo_code && !isCollectionPage">
        <span class="custom-font">{{ data.promo_code }}</span>
    </div>
</div>